import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import { addEventListener } from '@/util/event'

import LoadingBar from '@/components/LoadingBar'

Vue.use(VueRouter)

let homeChildren = []
const routerR = require.context('../views', true, /router.js$/)
routerR.keys().forEach(key => {
  let routerConfig = routerR(key).default
  let routerList = Array.isArray(routerConfig) ? routerConfig : [routerConfig]
  routerList.map(item => {
    let asyncFn = item.component
    if (typeof asyncFn === 'function') {
      // keep route name same with component name
      item.component = () =>
        asyncFn().then(res => {
          if (item.name) {
            res.default.name = item.name
          }
          return res
        })
    }
    homeChildren.push(item)
  })
})

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: to => {
      return { name: 'welcome' }
    },
    component: () =>
      import(/* webpackChunkName: "home" */ '../views/Index.vue'),
    children: homeChildren
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      // 是否需要登录鉴权
      loginAuth: false
    },
    component: () =>
      import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/signup',
    name: 'merchant-sign-up',
    meta: {
      // 是否需要登录鉴权
      loginAuth: false
    },
    component: () =>
      import(/* webpackChunkName: "signup" */ '../views/SignUp.vue')
  },
  {
    path: '/realname_guard',
    name: 'realname_guard',
    component: () =>
      import(
        /* webpackChunkName: "realname" */ '../views/realname/RealnameGuard.vue'
      )
  },
  {
    path: '*',
    name: '404',
    meta: {
      // 是否需要登录鉴权
      loginAuth: false
    },
    component: () =>
      import(/* webpackChunkName: "404" */ '@/projects/operation/views/404.vue')
  },
  {
    path: '/force_password_reset',
    name: 'force_password_reset',
    meta: {
      // 是否需要登录鉴权
      loginAuth: false
    },
    component: () =>
      import(
        /* webpackChunkName: "force_password_reset" */ '@/projects/merchant/views/ForceResetPassword.vue'
      )
  },
  {
    path: '/force_tx_password_reset',
    name: 'force_tx_password_reset',
    meta: {
      // 是否需要登录鉴权
      loginAuth: false
    },
    component: () =>
      import(
        /* webpackChunkName: "force_tx_password_reset" */ '@/projects/merchant/views/ForceResetTxPassword.vue'
      )
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  LoadingBar.start()
  // 不需要登录
  if (to.meta?.loginAuth === false) {
    next()
  } else if (store.state.user.login) {
    if (
      store.state.user.userInfo?.tmpryPswdYn === 'Y' &&
      to.name !== 'force_password_reset'
    ) {
      next({ name: 'force_password_reset' })
      return
    }
    if (
      store.state.user.userInfo?.tmpryTxPswdYn === 'Y' &&
      to.name !== 'force_tx_password_reset'
    ) {
      next({ name: 'force_tx_password_reset' })
      return
    }
    if (to.name === 'realname_guard') {
      if (store.state.user.userInfo.realNmCnfrmYn === 'Y') {
        next({ name: 'home' })
      } else {
        next()
      }
    } else if (store.state.user.userInfo.realNmCnfrmYn === 'N') {
      next({ name: 'realname_guard' })
    } else {
      next()
    }
  } else {
    next({ name: 'login' })
  }
})
router.afterEach((to, from, next) => {
  if (to.name === '404') {
    LoadingBar.error()
  } else {
    LoadingBar.finish()
  }
})
// 退出事件
addEventListener('LOGOUT_EVENT', () => {
  store.dispatch('user/logout', 'expired')
  router.replace({ name: 'login' })
})

export default router
